import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  overflow-x: auto;
  overflow-y: auto;
  height: 79vh;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 460px;
  max-width: 100%;
  height: 200px;
  background-color: var(--surface-1);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
  padding: 16px;
  margin-right: 8px;
  cursor: pointer;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    min-height: 160px;
    margin-right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
`;

export const ImageContainer = styled.div`
  margin-right: 16px;

  @media screen and (max-width: 768px) {
    margin-right: 0;
  }
`;

export const Image = styled.img`
  width: 150px;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 160px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
`;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  color: var(--text-heading);
  font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
`;

export const Info = styled.p`
  font-size: 16px;
  margin-bottom: 4px;
`;

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: var(--surface-1);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
  font-size: 24px;
  font-weight: bold;
`;
